export default {
  fromValue (val) {
    switch (val) {
      case 'pending':
        return 'Pendente'
      case 'canceled':
        return 'Cancelado'
      case 'approved':
        return 'Aprovado'
      case 'disapproved':
        return 'Reprovado'
      default:
        return val
    }
  }
}
